import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import {
  setOfflineData,
  getOfflineData,
  clearOfflineData,
} from "../../utils/offline-services";
import { toast } from "react-toastify";
import AppContext from "../../utils/context";
import AppLogo from "../../core/app-logo";
import FooterLinks from "../../core/footer-links";
import { USER_ROLES } from "../../utils/constants";
import LoginCard from "../../core/login-card";
import { Box, Button, Typography } from "@mui/material";
import FormGenerator from "../../core/form-generator";
import { loginFormConfig } from "./config";
import { handleFormValidation } from "../../utils";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const Login = () => {
  const { setUserDetails, setActiveRoute } = useContext(AppContext);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const [loginDetails, setLoginDetails] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const [searchParams] = useSearchParams();

  let userType = searchParams.get("type") || USER_ROLES.ADMIN;
  const { type } = useParams();
  useEffect(() => {
    if (getOfflineData("user")) {
      redirection(getOfflineData("user"));
    }
    const saveDetails = getOfflineData(`${userType}-loginDetails`);
    if (saveDetails) {
      setLoginDetails(saveDetails);
      setRememberMe(true);
    }
  }, []);

  const redirection = (user) => {
    if (type === USER_ROLES.OEM) {
      navigate("/oem");
    } else {
      navigate("/admin/engine-replacement-trend");
      setActiveRoute("Dashboard");
    }
  };

  const login = () => {
    const isValid = handleFormValidation(loginFormConfig, setErrors, formData);
    if (isValid) {
      let url = REST_URLS.LOGIN;
      if (type === USER_ROLES.OEM) {
        url = REST_URLS.OEM_LOGIN;
      }

      invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${url}`, formData)
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            const { user, oem, tokens = {} } = response;
            const userData = user || oem;
            if (type === USER_ROLES.OEM) {
              userData.role = USER_ROLES.OEM;
            } else {
              userData.role = USER_ROLES.ADMIN;
            }
            setUserDetails(userData);
            userData && setOfflineData("user", userData);
            tokens && setOfflineData("tokens", tokens);
            redirection(userData);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      login();
    }
  };
  return (
    <div className="home-container page-load">
      <img
        src={require("../../resources/icons/logo.png")}
        alt="logo"
        width={70}
      />

      <div className="login-con">
        <div className="login-left">
          <Box
            sx={{ display: "grid", gridGap: "10px" }}
            onKeyDown={handleKeyDown}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Login
            </Typography>
            <FormGenerator
              config={loginFormConfig}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              fieldGridSize={12}
              spacing={0}
            />
            <Typography
              variant="body1"
              sx={{ textAlign: "end", cursor: "pointer", mb: 2 }}
              className="primary-text"
              onClick={() => navigate(`/forgot-password/${type}`)}
            >
              Forgot password?
            </Typography>
            <Button variant="contained" onClick={login}>
              Sign In
            </Button>
          </Box>
        </div>

        <div className="login-right si-hide-mobile">
          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} />
              PROACTIVE
            </Typography>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} /> INNOVATIVE
            </Typography>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} /> CUSTOMER CENTRIC
            </Typography>
          </Box>
          <div className="engine-con">
            <img
              src={require("../../resources/icons/watermark.png")}
              alt="Simpson engine image"
              className="engine-image"
            />
          </div>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            Engineered for Performance, Supported with Care
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Login;
